<template>
    <BCard>
      <ValidationObserver ref="form" #default="{invalid}">
          <BForm @submit.prevent="onSubmit">
              <BRow>
                <vSelectValidated vsName="Course" :vsModel.sync="lesson.course" :vsOptions="courses" vsLabel="search_name" vsMd="4" vsRequired vsRules="required" @vsOnSearch="fetchCourses"/>
                <vSelectValidated v-if="$existsModule('Academy')" vsName="Teacher" :vsModel.sync="lesson.teacher_id" :vsOptions="teachers" :vsReduce="teacher=>teacher.id" vsLabel="full_name" vsMd="4" vsRequired vsRules="required" @vsOnSearch="fetchTeachers"/>
                <vSelectValidated v-if="$existsModule('Academy')" vsName="Classroom" :vsModel.sync="lesson.classroom_id" :vsOptions="classrooms" :vsReduce="classroom=>classroom.id" vsLabel="name" vsMd="4" :vsClearable="true" @vsOnSearch="fetchClassrooms"/>
                <DatepickerValidated vsName="Start date" :vsModel.sync="lesson.start_date" vsMd="4" vsRequired vsRules="required" :vsMin="lesson.course ? lesson.course.start_date : ''" :vsMax="lesson.course ? lesson.course.end_date : ''"/>
                <TimepickerValidated  vsName="Hora de inicio" :vsModel.sync="lesson.start_time" vsMd="4" vsRequired></TimepickerValidated>
                <TimepickerValidated  vsName="Hora de fin" :vsModel.sync="lesson.end_time" vsMd="4" vsRequired ></TimepickerValidated>
                <CheckboxValidated vsName="" :vsModel.sync="lesson.is_extra" vsLabel="Is extra lesson?" />
                <NumberInputValidated vsName="Amount" :vsModel.sync="lesson.amount" vsMd="4" v-if="lesson.is_extra" />
                <TextareaValidated vsName="Observations" :vsModel.sync="lesson.observations" />
              </BRow>

              <!-- Action Buttons -->
              <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit" id="submitbutton"> {{ $t("Save Changes") }} </BButton>
              <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'lessons' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BForm>
      </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BRow, BForm, BButton, BCol, } from 'bootstrap-vue';
import { onUnmounted, ref, watch} from '@vue/composition-api';
import { ValidationObserver } from 'vee-validate';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import TimepickerValidated from '@/components/forms/TimepickerValidated.vue'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import popups from '@/hooks/popups';
import formValidation from '@core/comp-functions/forms/form-validation';
import { getClassrooms } from '@/composables/classroomService'
import { getCourses } from '@/composables/courseService'
import { getTeachers } from '@/composables/teacherService'
import { addLesson } from '@/composables/lessonService'
import router from '@/router'
import { existsModule } from '@/hooks/modulesUtils';
export default {
    components: { BCard, BRow, BForm, BButton, ValidationObserver, TextInputValidated, TextareaValidated, vSelectValidated, DatepickerValidated, NumberInputValidated,  BCol, CheckboxValidated, TimepickerValidated},
    setup() {
        const { errorToast } = popups()
        const { getValidationState } = formValidation()
        const courses = ref([])
        const teachers = ref([])
        const classrooms = ref([])
        const lesson = ref({
            'amount': null,
            'course': null,
            'couse_id':null, 
            'teacher_id': null,
            'start_date': null,
            'start_time':null,
            'end_time':null,
            'is_extra': false,
            'observations': ''
        })

        const startTime=ref(null)
        const onSubmit = function(){
          this.$refs.form.validate().then(success => {
              if(success) {
                if (!lesson.value.start_time) {
                    errorToast('Introduce una hora de comienzo')
                    return
                }

                if (!lesson.value.end_time) {
                    errorToast('Introduce una hora de fin')
                    return
                }

                document.getElementById('submitbutton').disabled=true;
                lesson.value.course_id=lesson.value.course.id
                createLesson(lesson.value)
              }
          })
        }

        const fetchClassrooms = async function (query) {
            if (existsModule('Academy')) {
                let response = await getClassrooms({q:query})
                classrooms.value = response.data.classrooms
            }
        }

        const fetchCourses = async function (query) {
            let response = await getCourses({q:query})
            courses.value = response
        }

        const fetchTeachers = async function (query) {
            if (existsModule('Academy')) {
                let response = await getTeachers({q:query})
                teachers.value = response.data.teachers
            }
        }
        
        const createLesson = async function (lesson) {
            let response = await addLesson(lesson) 
            if (response.data.success) {
                router.push({ name: 'lessons' });
            } else {
                errorToast("Error añadiendo clase")
            }
        }

        fetchClassrooms(null)
        fetchCourses(null)
        fetchTeachers(null)

        
        watch (lesson, () => {
            if (!lesson.value.is_extra) {
                lesson.value.amount=null
            }
        }, {deep:true})

        return {
            onSubmit,
            courses,
            teachers,
            lesson,
            getValidationState,
            startTime,
            classrooms,
            fetchCourses, 
            fetchTeachers, 
            fetchClassrooms
        }
    }
}
</script>
